// extracted by mini-css-extract-plugin
export var childrenContainer = "_3y-0";
export var virtualScrollArea = "_3y-1";